import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';

export interface ConfirmationConfig {
  autoFocusConfirm?: boolean;
  cancelText?: string;
  cancelColor?: 'primary' | 'danger';
  confirmText?: string;
  confirmColor?: 'primary' | 'success';
}

@Component({
  selector: 'confirmation-dialog',
  templateUrl: './confirmation.component.html'
})
export class ConfirmationComponent implements OnInit {
  @Input() title: string;
  private _confirmationConfig: ConfirmationConfig = {
    autoFocusConfirm: true,
    cancelText: 'Cancel',
    cancelColor: 'primary',
    confirmText: 'OK',
    confirmColor: 'primary',
  };

  static async showConfirmation(modals: NgbModal, title: string, confirmationConfig?: ConfirmationConfig): Promise<boolean> {
    const modal = modals.open(ConfirmationComponent, {backdrop: 'static', keyboard: false});
    const confirmation: ConfirmationComponent = modal.componentInstance;
    confirmation.title = title;
    confirmation.confirmationConfig = confirmationConfig;
    return await modal.result;
  }

  constructor(public modal: NgbActiveModal) {}

  ngOnInit(): void {}

  set confirmationConfig(confirmationConfig: ConfirmationConfig) {
    if (confirmationConfig) {
      Object.assign(this._confirmationConfig, confirmationConfig);
    }
  }

  get confirmationConfig(): ConfirmationConfig {
    return this._confirmationConfig;
  }

  get cancelNgbAutofocus(): '' | null {
    return this.confirmationConfig.autoFocusConfirm ? null : '';
  }

  get confirmNgbAutofocus(): '' | null {
    return this.confirmationConfig.autoFocusConfirm ? '' : null;
  }
}
